package com.milta.core.localization.translations.fr

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Annuler",
    confirm = "Confirmer",
    save = "Enregistrer",
    delete = "Supprimer",
    back = "Retour",
    loading = "Chargement…",
    retry = "Réessayer",
    language = "Langue",
    welcomeTitle = "Bienvenue sur Milta",
    welcomeSubtitle = "Votre assistant de tournée intelligent",
    alreadyHaveAccount = "J'ai déjà un compte",
    createAccount = "Créer un compte",
    continueWithGoogle = "Continuer avec Google",
    continueWithApple = "Continuer avec Apple",
    oauthErrorGeneric = "Une erreur est survenue lors de la connexion. Réessayez.",
    oauthAppleWebComingSoon = "La connexion avec Apple arrive bientôt sur le web.",
    oauthDriverAccountNotAllowedOnWeb = "Ce compte chauffeur ne peut pas accéder au tableau de bord web. Connectez-vous depuis l'application mobile.",
    oauthAccountNotFoundOnWeb = "Aucun compte Milta n'a été trouvé pour ce compte Google.",
    errorOffline = "Pas de connexion internet.",
    navTourneesDuJour = "Tournées du jour",
    navAjouterUneTournee = "Ajouter une tournée",
    navHistoriqueDesPreuves = "Historique des preuves",
    navParametres = "Paramètres",
    sidebarRoleManagerLabel = "Gestionnaire",
    noDeliveriesYetTitle = "Aucune livraison",
    noDeliveriesYetSubtitle = "Cliquez sur « Ajouter des livraisons » pour en ajouter",
    optimizationUnavailableExplanation = "Voulez-vous créer la tournée sans optimisation, ou réessayer ?",
    createWithoutOptimizationAction = "Créer sans optimisation",
    gpsAppSheetTitle = "Choisir une application de navigation",
    addressSearchingLabel = "Recherche en cours…",
)
